const breadCrumb = "Lotação de Servidores - Manutenção de Servidores";
const parentRoute = "/cadastro-de-servidor";

const routes = [
  {
    path: "/contrato-de-servidores",
    name: "contrato-de-servidores-busca",
    meta: {
      allowedPermissions: ["contratos_servidor_list", "area_curso_list"],
      breadCrumb: breadCrumb,
      pageTitle: "Contrato de Servidores",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ContratoDeServidores/ContratoDeServidoresBusca.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/contrato-de-servidores",
    name: "contrato-de-servidores",
    meta: {
      allowedPermissions: ["contratos_servidor_list", "area_curso_list"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Contratos do Servidor",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ContratoDeServidores/ContratoDeServidoresHome.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/contrato-de-servidores/novo",
    name: "contrato-de-servidores-novo",
    meta: {
      allowedPermissions: ["contratos_servidor_insert"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Contratos do Servidor - Novo",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ContratoDeServidores/ContratoDeServidoresCad.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/contrato-de-servidores/editar/:id",
    name: "contrato-de-servidores-editar",
    meta: {
      allowedPermissions: ["contratos_servidor_update"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Contratos do Servidor - Editar",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ContratoDeServidores/ContratoDeServidoresEdit.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/contrato-de-servidores/visualizar/:id",
    name: "contrato-de-servidores-visualizar",
    meta: {
      allowedPermissions: ["contratos_servidor_show"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Contratos do Servidor - Visualizar",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ContratoDeServidores/ContratoDeServidoresShow.vue"
      ),
  },
];

export default routes;
